import React from "react";
import { bindActionCreators } from "redux";
import * as modalActions from "../../redux/actions/modalActions";
import * as forgotPasswordActions from "../../redux/actions/forgotPasswordAction";
import * as loginActions from "../../redux/actions/loginActions";
import { useSelector, useDispatch } from "react-redux";
import PasswordExpiryComponent from "../../components/Login/PasswordExpiry";
import PropTypes from "prop-types";

const PasswordExpiry = (props, context) => {
  const dispatch = useDispatch();
  const forgotPasswordReducer = useSelector((state) => state.forgotPasswordReducer);
  const loginReducer = useSelector((state) => state.loginReducer);
  const modalReducer = useSelector((state) => state.modalReducer);

  const modalAction = bindActionCreators(modalActions, dispatch);
  const forgotPasswordAction = bindActionCreators(forgotPasswordActions, dispatch);
  const loginAction = bindActionCreators(loginActions, dispatch);

  const closeRemoveModal = () => {
    modalAction.closeRemoveModal();
  };
  const openSetModal = (children, size) => {
    modalAction.openSetModal(children, size);
  };

  const resetIsPasswordExpired = (isPasswordExpired) => {
    loginAction.resetIsPasswordExpired(isPasswordExpired);
  }

  const changeExpiryPassword = (changePasswordInfo) => {
    loginAction.changeExpiryPassword(changePasswordInfo,loginReducer.authToken);
  }

  return (
    <PasswordExpiryComponent
      closeRemoveModal={closeRemoveModal}
      context={context}
      {...props}
      openSetModalAction={openSetModal}
      forgotPasswordReducer={forgotPasswordReducer}
      resetIsPasswordExpired={resetIsPasswordExpired}
      modalReducer={modalReducer}
      changeExpiryPassword={changeExpiryPassword}
    />
  );
};
PasswordExpiry.contextTypes = {
  t: PropTypes.func.isRequired,
};

export default PasswordExpiry;
